export const ELEMENTS_PER_PAGE_FOR_AUTOCOMPLETE = 10;
